import Model, { attr, belongsTo } from '@ember-data/model';

export default class PrescreenerAnswerModel extends Model {
  @belongsTo('treatable-client', { polymorphic: true, async: false }) client;
  @belongsTo('prescreener-question', { async: false }) prescreenerQuestion;

  @attr() answers;
  @attr() files;
}
